import generic from 'containers/purchase/machines/generic_machine_config'
import volcano from 'containers/purchase/machines/volcano_machine_config'
import lowCost from 'containers/purchase/machines/lct_machine_config'
import fareharbor from 'containers/purchase/machines/fareharbor_machine_config'
import clorian from 'containers/purchase/machines/clorian_machine_config'
import orsag from 'containers/purchase/machines/orsag_machine_config'
import tourcms from 'containers/purchase/machines/tourcms_machine_config'
import janto_iframe from 'containers/purchase/machines/janto_iframe_config'
import mixentradas_iframe from 'containers/purchase/machines/mixentradas_iframe_config'
import experticket from 'containers/purchase/machines/experticket_config'
import transfer from 'containers/purchase/machines/transfer_machine_config'
// import servantrip from 'containers/purchase/machines/servantrip_machine_config'
import avis from 'containers/purchase/machines/avis_machine_config'
import onebox from 'containers/purchase/machines/onebox_machine_config'
import iryo from 'containers/purchase/machines/iryo_machine_config'
import e_vtc from 'containers/purchase/machines/e_vtc_machine_config'

const machineConfig = (machineApi, data) => {
  const configsMap = {
    'generic': generic,
    'low_cost': lowCost,
    'fareharbor': fareharbor,
    'clorian': clorian,
    'orsag': orsag,
    'tourcms': tourcms,
    'janto_iframe': janto_iframe,
    'experticket': experticket,
    'transfer': transfer,
    'volcano': volcano,
    'mixentradas_iframe': mixentradas_iframe,
    // 'servantrip': servantrip,
    'avis': avis,
    'onebox': onebox,
    'iryo': iryo,
    'e_vtc': e_vtc,
  }

  return configsMap[machineApi](data)
}

export default machineConfig
